import {
  IExpressionFunction,
  ITemplateOptions,
  ITemplateScopeOptions,
  IValidator,
  IWatcher,
} from "AngularFormly";
import { RecordSelectAsyncTemplateOptions } from "./types";
import { IRecordRepeaterTemplateOptions } from "./types/repeater/controller";
import {
  RecordGridViewService,
  vsServiceName as RecordGridViewServiceName,
} from "../../views/recordGridView";
import { get, join, set, split } from "lodash";
import {
  LookupModalService,
  vsServiceName as LookupModalServiceName,
} from "../../lookup/lookupModal";
import { IScope } from "angular";

import {
  SelectUserFieldConfig,
  vsTypeName as userAuthType,
} from "./types/userAuth";
import { LookupManagementService } from "../../lookup/lookupManagement";
import { Record } from "../../server/crud";

export const vsName = "fieldConfigurationHelperService";

export interface LookupFieldConfig {
  showAddButtonPermission?: string;
  showAddButton?: boolean;
  watcher?: IWatcher | IWatcher[] | undefined;
  referenceFieldKey?: any;
  expressionProperties?:
    | { [key: string]: string | IExpressionFunction | IValidator }
    | undefined;
  label?: string;
  key: string;
  getDefaultItem?: (model: any) => { Id: any; Name: any };
  objectName: string;
  machineField?: boolean;
  required?: boolean;
  hideExpression?: string | IExpressionFunction;
  className?: string;
}

export class FieldConfigurationHelperService {
  static $inject = [RecordGridViewServiceName, LookupModalServiceName];

  constructor(
    private readonly recordGridViewService: RecordGridViewService,
    private readonly lookupModalService: LookupModalService
  ) {}

  lookupField(
    lookupManagementService: LookupManagementService,
    config: LookupFieldConfig
  ) {
    const gridConfiguration = this.recordGridViewService.getGridConfiguration(
      config.objectName
    )!;

    const referenceFieldKey = config.referenceFieldKey
      ? config.referenceFieldKey
      : config.key!.substring(0, config.key!.length - 2); //strip off Id off of field key;

    const defaultItemFactory =
      config.getDefaultItem ?? FieldConfigurationHelperService.getDefaultItem;

    const fieldDefinition = this.selectAsyncField({
      queryUrl: gridConfiguration.gridDataSource!.url,
      getDefaultItem: (formModel: any) =>
        defaultItemFactory(get(formModel ?? {}, referenceFieldKey)),
      label: config.label ?? gridConfiguration.nameSingular,
      key: config.key,
      required: config.required,
      expressionProperties: config.expressionProperties ?? {},
      hideExpression: config.hideExpression,
      watcher: config.watcher,
      onSelect: (selectedItem: any, model: any) =>
        onSelect(selectedItem, model),
      className: config.className,
      queryBuilder: (search: string) => {
        return {
          NameContains: search,
          Disabled: false,
        };
      },
    });

    if (config.showAddButton) {
      fieldDefinition.templateOptions!.addonRight =
        this.lookupModalService.getDropdownAddAddon(
          lookupManagementService,
          config.objectName,
          (selectedItem: any, _: IScope, model: any) => {
            onSelect(selectedItem, model);
            set(model, config.key, selectedItem.Id);
          },
          config.showAddButtonPermission ?? ""
        );
    }
    return fieldDefinition;

    function onSelect(selectedItem: any, formModel: any) {
      set(formModel, referenceFieldKey, selectedItem);
    }
  }

  selectUserField(
    config: SelectUserFieldConfig
  ): AngularFormly.IFieldConfigurationObject {
    return {
      key: config.key,
      name: config.name ?? config.key,
      type: userAuthType,
      expressionProperties: config.expressionProperties,
      templateOptions: {
        label: config.label,
        initialItemSelector: config.initialItemSelector,
        onSelect: config.onSelect,
      },
      hideExpression: config.hideExpression,
      watcher: config.watcher,
      className: config.className,
    };
  }

  selectAsyncField(
    config: RecordSelectAsyncTemplateOptions
  ): AngularFormly.IFieldConfigurationObject {
    return {
      key: config.key,
      name: config.name ?? config.key,
      type: "recordSelectAsync",
      templateOptions: config,
      model: config.model,
      expressionProperties: config.expressionProperties,
      hideExpression: config.hideExpression,
      watcher: config.watcher,
      className: config.className,
    };
  }

  gridSelectAsyncField(
    config: RecordSelectAsyncTemplateOptions
  ): AngularFormly.IFieldConfigurationObject {
    return {
      key: config.key,
      name: config.name ?? config.key,
      type: "recordGridSelectAsync",
      templateOptions: config,
      model: config.model,
      expressionProperties: config.expressionProperties,
      watcher: config.watcher,
      className: config.className,
    };
  }

  repeaterField(
    config: IRecordRepeaterTemplateOptions
  ): AngularFormly.IFieldConfigurationObject {
    return {
      key: config.key,
      name: config.name ?? config.key,
      type: "recordRepeater",
      id: config.name ?? config.key,
      templateOptions: config,
    };
  }

  static getDefaultItem(model: any) {
    return {
      Id: model?.Id,
      Name: model?.Name,
    };
  }
}

// {
//   key: "MealLogReasonId",
//   name: "MealLogReasonId",
//   type: "selectAsync",
//   templateOptions: {
//     label: "Reason",
//     required: true,
//     query: [CommonMachineServerName, function (CommonMachineServer) {
//       return function (search) {
//         return CommonMachineServer.mealLogReasonsQuery({
//           NameContains: search,
//           Skip: 0,
//           Take: 25,
//           OrderBy: 'Name'
//         })
//       }
//     }],
//     getDefaultItem: function (model) {
//       return {
//         Id: model.MealLogReasonId,
//         Name: model.MealLogReasonName
//       }
//     }
//   }
